<template>
    <div v-if="field">
        <b-input-group>
            <b-input-group-prepend v-if="$attrs.prefix">
                <b-input-group-text> {{ $attrs.prefix }} </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input 
            :type="field.type" 
            :id="field.key" 
            :placeholder="field.constraints.placeholder"
            v-model="content"
            autocomplete="off"
            v-bind="$attrs"
            ></b-form-input>
            <b-input-group-prepend v-if="$attrs.sufix">
                <b-input-group-text> {{ $attrs.sufix }}</b-input-group-text>
            </b-input-group-prepend>

            <b-form-invalid-feedback :id="field.key" style="display:block">
                {{ errors[0] || null }}
            </b-form-invalid-feedback>

            <b-form-invalid-feedback :id="field.key" style="display:block" v-if="errors.length < 1 && extendErrors !== undefined">
                {{ translateExtendedError(extendErrors[0]) || null }}
            </b-form-invalid-feedback>
         </b-input-group>
    </div>
</template>

<script>
export default {
    name: "IdentityField_Password",
    props: {
        field: {
            type: Object
        },
        value: {
            type: String | Number,
            default: ""
        },
        extendErrors: {
            type: Array
        },
        page: {
            type: String
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: [],
            errorTrans: {
                "password_not_match": this.translator("identityField.passwordDoesntMatch")
            }
        }
    },
    computed: {
        content: {
            get() {
                return this.value
            },

            set(val) {
                this.check(val)
                this.$emit('input', val);
            }
        },
        constraints() {
            let constr = this.field.constraints

            return constr
        }
    },
    watch: {
        content(val) {
            this.check(val)
        }
    },
    methods: {
        check(val) {
            this.errors = []

            if (val == "" && this.constraints.required && this.page !== "model_edit") {
                 this.errors.push(this.translator("identityField.requiredField"))
            }
            
            if (this.constraints.length !== undefined) {
                if (this.constraints.length.max !== null && this.constraints.length.max > 0) {
                    if (val !== null) {
                        if (val.length > this.constraints.length.max && val.length > 0) {
                            this.errors.push(
                                this.translator("identityField.cantBeMoreThenChars", {
                                    max: this.constraints.length.max
                                })
                            )
                        }
                    }
                    
                }
                
                if (this.constraints.length.min !== null) {
                    if (val !== null) {
                        if (val.length < this.constraints.length.min && val.length > 0) {
                            this.errors.push(
                                this.translator("identityField.cantBeLessThenChars", {
                                    min: this.constraints.length.min
                                })
                            )
                        }
                    }
                }
            }

            if (this.constraints.not_allowed_words !== undefined) {
                let notAllowedWords = this.constraints.not_allowed_words.split(",")
                notAllowedWords.forEach(word => {
                    word = word.trim()

                    if (word != "") {
                        if (val.indexOf(word) !== -1) {
                            if (word.length < 2) {
                                this.errors.push(
                                    this.translator("identityField.symbolNotAllowed", {
                                        symbol: word
                                    })
                                )
                            } else {
                                this.errors.push(
                                    this.translator("identityField.wordNotAllowed", {
                                        symbol: word
                                    })
                                )
                            }
                        }  
                    }              
                })
            }

            if (this.constraints.regex !== undefined || this.constraints.regex !== "") {
                let re = new RegExp(this.constraints.regex)
                if (! re.test(val)) {
                    this.errors.push(this.translator("identityField.invalidInput"))
                }
            }
                
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0 || this.extendErrors.length > 0})
        },

        translateExtendedError(err) {
            return this.errorTrans[err]
        }
    },
    mounted() {
        this.check(this.content)
        if (this.page == "model_edit") {
            this.content = "__PASSWORD__";
        }
    }
}
</script>